import { render } from "./PuzzleBoard.vue?vue&type=template&id=d4c8ccee&scoped=true"
import script from "./PuzzleBoard.vue?vue&type=script&lang=js"
export * from "./PuzzleBoard.vue?vue&type=script&lang=js"

import "./PuzzleBoard.vue?vue&type=style&index=0&id=d4c8ccee&scoped=true&lang=css"

import exportComponent from "/Users/matejvehar/git/mvehar/pi-slidoos/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d4c8ccee"]])

export default __exports__